import { MutationTree } from 'vuex';

import { RootStateI } from './state';

const mutations: MutationTree<RootStateI> = {
  toggleSidebar(state) {
    state.sidebar = !state.sidebar;
  },
  toggleFilterSidebar(state) {
    state.filterSidebar = !state.filterSidebar;
  },
  closeSidebar(state) {
    state.sidebar = false;
  },
};

export {
  mutations,
};
